module.exports = __webpack_public_path__ + "static/media/history_29.f2330b7b.jpg";